import React from 'react';
import PropTypes from 'prop-types';
import ListItemText from '@material-ui/core/ListItemText';
import Autocomplete, { highlightSubstring } from '../Autocomplete';
import { useFormContext } from '../Form';

const CountrySelect = props => {
  const formContext = useFormContext();
  const { watch, setValue } = formContext || {};
  const { value: providedValue, valueOnly, options, name, onChange } = props;
  const currentValue = providedValue ?? (watch && watch(name));
  const value = valueOnly
    ? options.find(suggestion => suggestion.value === currentValue)
    : currentValue;

  const countryToFlag = iso =>
    iso &&
    iso.toUpperCase().replace(/./g, char => String.fromCodePoint(char.charCodeAt(0) + 127397));

  const handleSetValue = (ev, newValue) => {
    let updatedValue = newValue;

    if (typeof updatedValue === 'object' && valueOnly) {
      updatedValue = updatedValue.value;
    }

    if (formContext && !onChange) {
      setValue(name, updatedValue);
      return;
    }

    if (onChange) {
      onChange(ev, updatedValue);
    }
  };

  const handleOnChange = async (ev, newValue) => {
    try {
      if (newValue) {
        handleSetValue(ev, newValue);
      } else {
        handleSetValue(ev, null);
      }
    } catch (err) {
      handleSetValue(ev, null);
    }
  };

  const renderOption = (option, { inputValue = '' } = {}) => {
    let label = option;

    if (typeof option === 'object') {
      // eslint-disable-next-line prefer-destructuring
      label = option.label;
    }

    return (
      <ListItemText
        primary={
          <>
            {countryToFlag(option.value)} {highlightSubstring(label, inputValue)}
          </>
        }
      />
    );
  };

  return (
    <Autocomplete
      {...props}
      value={value}
      onChange={handleOnChange}
      renderOption={renderOption}
      InputProps={value && { startAdornment: countryToFlag(value?.value ?? value) }}
      autocomplete="off"
    />
  );
};

CountrySelect.propTypes = {
  ...Autocomplete.propTypes,
  valueOnly: PropTypes.bool,
};

CountrySelect.defaultProps = {
  ...Autocomplete.defaultProps,
  valueOnly: false,
};

export default CountrySelect;
